// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { assertUserNotAuthenticated } from '../utils/signInHelpers';
import { signInWithCustomAuth } from './signInWithCustomAuth';
import { signInWithCustomSRPAuth } from './signInWithCustomSRPAuth';
import { signInWithSRP } from './signInWithSRP';
import { signInWithUserPassword } from './signInWithUserPassword';
/**
 * Signs a user in
 *
 * @param input -  The SignInInput object
 * @returns SignInOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException }
 *  - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */
export async function signIn(input) {
    const authFlowType = input.options?.authFlowType;
    await assertUserNotAuthenticated();
    switch (authFlowType) {
        case 'USER_SRP_AUTH':
            return signInWithSRP(input);
        case 'USER_PASSWORD_AUTH':
            return signInWithUserPassword(input);
        case 'CUSTOM_WITHOUT_SRP':
            return signInWithCustomAuth(input);
        case 'CUSTOM_WITH_SRP':
            return signInWithCustomSRPAuth(input);
        default:
            return signInWithSRP(input);
    }
}
